<template>
  <div class="h-100 ph5-l ph3-m ph2 flex flex-column items-center textColor overflow-y-scroll">
    <h1 class="w-100 tc f1-ns f3">{{$t("help.title")}}</h1>
    <div class="w-100">
      <div class="flex flex-wrap justify-center w-100">
        <div class="w-50-ns w-100 ph3-ns ph1">
          <h2 class="f3-ns f4 tl-ns tc bt bn-ns pt3 pt0-ns">{{$t("help.contactForm.title")}}</h2> 
          <span v-if="provider.name">**{{$t("help.unsubscribe")}}<span class="bold ttu">{{this.provider.name}}</span>, {{$t("help.send")}} {{this.provider.msj}} {{$t("help.to")}} {{this.provider.number}}</span>
          <form class="mtop" @submit.prevent="sendEmail">
            <div class="flex flex-wrap w-100">
              <div class="flex flex-column w-40-l w-100 mh1 textColor">
                <label for="name" class="b db mv1">{{$tc('users.name', 1)}}:</label>
                <input class="w-100 ph1 input" v-model="name" id="name" :placeholder="$tc('users.name', 1)" @blur="$v.name.$touch"/>
                <span class="errorText ma1 f7" v-if="$v.name.$error && !$v.name.required">{{$t("error.nameRequired")}}</span>
              </div>
              <div class="flex flex-column w-40-l w-100 mh1 textColor">
                <label for="email" class="b db mv1">{{$t("users.email")}}:</label>
                <input class="w-100 ph1 input" v-model="email" id="email" :placeholder="$t('users.email')" @blur="$v.email.$touch"/>
                <span class="errorText ma1 f7" v-if="$v.email.$error && !$v.email.required">{{$t("error.emailRequired")}}</span>
                <span class="errorText ma1 f7" v-if="$v.email.$error && !$v.email.email">{{$t("error.emailInvallid")}}</span>
              </div>
            </div>
            <label for="message" class="b db mv1">{{$t("form.message")}}:</label>
            <span class="errorText ma1 f7" v-if="$v.message.$error && !$v.message.required">{{$t("error.messageRequired")}}</span>
            <textarea id="message" name="message" v-model="message" class="h4 f7 db w-100 ba pa2 br2 mb2 textAreaHelp" @blur="$v.message.$touch"/>
            <div class="w-100 flex justify-center">
              <input class="btn w-25 pointer" type="submit" :value="$t('form.send')">
            </div>
          </form>
        </div>
      </div>
    </div>
    <hr>
    <div class="flex flex-column">
      <h1 class="tc bt pt3 w-100 f3-ns f4">{{$t("help.faqs")}}</h1>
      <div class="mw8">
        <component v-bind:is="faqs"></component>
      </div>
    </div>
  </div>
</template>

<script>
  import FaqsEs from './FaqsEs.vue'
  import FaqsEn from './FaqsEn.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import { required, email } from 'vuelidate/lib/validators'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'help',
    data () {
      return {
        name: '',
        email: '',
        message: '',
        provider: {
          name: null,
          msj: null,
          number: null,
          email: null
        }
      }
    },
    components: {
      FontAwesomeIcon,
      FaqsEs,
      FaqsEn
    },
    created () {
      this.provider.name = localStorage.getItem('provider')
      this.provider.msj = localStorage.getItem('provider_msj')
      this.provider.number = localStorage.getItem('provider_n')
      this.provider.email = localStorage.getItem('provider_email')
    },
    computed: {
      ...mapGetters('user', [
        'error'
      ]),
      faqs () {
        return 'faqs-' + this.$i18n.locale
      }
    },
    methods: {
      ...mapActions('user', [
        'contact'
      ]),
      sendEmail () {
        if (!this.$v.$invalid) {
          this.contact({email: this.email, name: this.name, message: this.message, provider: this.provider.email}).then(() => {
            this.$toasted.show(this.$t('help.contactForm.success'), {type: 'success'})
          }).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
        } else {
          this.$v.$touch()
        }
      }
    },
    validations: {
      email: {
        email,
        required
      },
      name: {
        required
      },
      message: {
        required
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '~@/variables.scss';

  .input {
    background-color: $background-color;
    border: 1px solid #DDDEDF;
  }

  .textAreaHelp {
    background-color: $background-color;
    color: $text-color;
  }

  .bold {
    font-weight: bold;
  }

  .mtop {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/help/Help.vue